<script setup>
import { ref, watch, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { Tooltip } from 'flowbite-vue'
import { useNotificationsStore } from '@/stores/NotificationsStore'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import NotificationTopMenu from '@/views/Notifications/components/NotificationTopMenu.vue'
import NotificationItems from '@/views/Notifications/components/NotificationItems.vue'

const notificationsStore = useNotificationsStore()
const route = useRoute()
const tooltipRef = ref(null)

const handleTooltipHover = () => {
  notificationsStore.fetchInprogressJobs()
  notificationsStore.fetchNotificationsPreviews()
}

// Close tooltip when route changes
watch(() => route.path, () => {
  nextTick(() => {
    const tooltipElement = document.querySelector('.v-popper__popper')
    if (tooltipElement) {
      // Prefer using the Flowbite tooltip instance if available
      tooltipRef.value?.hide?.()

      // Fallback: remove the tooltip DOM directly
      setTimeout(() => {
        if (tooltipElement && tooltipElement.parentNode) {
          tooltipElement.remove()
        }
      }, 100)
    }
  })
})

</script>
<template>
  <Tooltip
    ref="tooltipRef"
    placement="bottom-end"
    class="notifications-menu"
    theme="light"
    :trigger="'click'"
  >
    <template #trigger>
      <div 
        @click="handleTooltipHover"
        class="relative cursor-pointer w-8 h-8 hover:bg-blue-600 rounded flex items-center justify-center"
      >

        <img src="@/assets/images/icons/bell.svg" class="h-8 w-8" />
        <div v-if="notificationsStore.unreadNotificationsCount" class="absolute bottom-1 right-0 w-fit px-1 bg-red-500 rounded-full flex items-center justify-center">
          <span class="text-[10px] font-semibold text-white">{{ notificationsStore.unreadNotificationsCount }}</span>
        </div>
      </div>
    </template>
    <template #content>
      <div class="base-tooltip-light flex flex-col rounded-lg max-h-[500px] overflow-y-auto w-[384px] border border-gray-200 p-0">
        <header class="sticky top-0 z-10 bg-white border-b border-gray-200 py-2 px-3 flex items-center justify-between">
          <h2 class="text-lg font-semibold leading-[150%] text-gray-900">Notifications</h2>
          <div class="flex items-center gap-x-2" >
            <!-- <span @click="notificationsStore.markAllAsRead" v-if="notificationsStore.inprogressJobsLength" class="text-xs font-medium leading-[150%] text-tint-1 cursor-pointer">Mark all as read</span> -->
            <NotificationTopMenu />
          </div>
        </header>
        <div v-if="notificationsStore.notificationsLoading" class="flex justify-center items-center h-full">
          <LoadingSpinner :background="'bg-gray-100'" :width="'48px'" :height="'48px'" />
        </div>

        <div v-else-if="!notificationsStore.preparedInprogressJobs.length && !notificationsStore.preparedNotificationsPreviews?.length" class="flex flex-col gap-y-2 h-[390px] items-center justify-center">
          <div>
            <img src="@/assets/images/icons/bell_flat.svg" />
          </div>
          <span class="text-xs font-bold leading-[150%] text-gray-500">You’re all caught up</span>
        </div>
        <template v-else>
          <NotificationItems
            :getter="'preparedInprogressJobs'"
            :type="'job'"
            :readableState="false"
          />
          <NotificationItems
            :getter="'preparedNotificationsPreviews'"
            :type="'preview'"
          />
        </template>
        
      </div>
    </template>
  </Tooltip>
</template>